import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/imprint",
    name: "Impressum",
    component: () => import("../views/Imprint.vue"),
  },
  {
    path: "/cart",
    name: "Cart",
    component: () => import("../views/Cart.vue"),
  },
  {
    path: "/legal",
    name: "Legal",
    component: () => import("../views/Legal.vue"),
  },
  {
    path: "/dataprotection",
    name: "Dataprotection",
    component: () => import("../views/DataProtection.vue"),
  },
  {
    path: "/categorie",
    name: "Categorie",
    component: () => import("../views/Categories.vue"),
  },
  {
    path: "/products/:id",
    name: "Products",

    component: () => import("../views/Products.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/vendors",
    name: "Vendors",
    component: () => import("../views/Vendors.vue"),
  },

  {
    path: "/newproduct",
    name: "New Product",

    component: () => import("../views/NewProduct.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/updatevendorinfo",
    name: "Update Vendor Info",

    component: () => import("../views/UpdateVendorInfo.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
